<template lang="pug">
  .columns.is-vcentered
    .column.is-3-desktop
    .login.column.is-6
      section.section
        .has-text-centered
          img.login-logo(:src="ecoinventLogo")
          .content
            h3 {{ $t('Data Converter Password Reset') }}
          form(@submit.prevent="startRecovery")
            b-field(:label="$t('Enter Your Email')")
              b-input(type="email" v-model="email" icon="envelope"
              @input="clearError" required :disabled="submitting || done")
            transition(name="fade")
              .error(v-if="errorMessage" key="errorMessage")
                p.is-danger {{ errorMessage }}
            transition(type="fade")
              b-message(v-if="done" key="done" type="is-success" has-icon)
                | {{ $t('Thank you!')}}
                <br>
                | {{ $t('Please check your email inbox to complete the password recovery.') }}
            .has-text-centered
              input.button.is-vcentered.is-primary.is-outlined(
              type="submit" :value="$t('Recover My Password')" :disabled="submitting || done")
    .column.is-3-desktop
</template>

<script>
import { recoverPassword } from '../utils/api'

export default {
  name: 'RecoverPassword',
  data() {
    return {
      email: '',
      errorMessage: null,
      submitting: false,
      done: false,
      ecoinventLogo: require('../assets/ecoinvent Brand mark.png')
    }
  },
  methods: {
    startRecovery() {
      if (this.submitting) {
        return
      }
      this.submitting = true
      recoverPassword(this.email)
        .then(() => {
          this.done = true
        })
        .catch((error) => {
          if (error.response.status === 400 && error.response.data.email) {
            this.errorMessage = this.$t('Sorry, this email address has not been registered.')
          } else {
            this.errorMessage = this.$t('An unexpected error occurred during password recovery.')
          }
        })
        .finally(() => {
          this.submitting = false
        })
    },
    clearError() {
      this.errorMessage = null
    }
  }
}
</script>

<style scoped lang="scss">
  .login {
    height: 80vh;
  }

  .input {
    border-radius: 50px;
  }

  .button {
    margin-top: 20px;
    margin-bottom: 20px;
    min-width: 150px;
  }

  .login-logo {
    margin: 0 2rem 5rem;
    max-height: 100px;
  }

  .is-danger {
    color: #e01a1a;
  }
</style>



// WEBPACK FOOTER //
// src/components/RecoverPassword.vue